import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApi, useClientOptions } from "@/hooks/useApi";
import { PageHeader, DataTable, StatusBadge, ErrorBox } from "@/components/common/ui-bits";
import { FormDialog } from "@/components/common/FormDialog";
import { fmtDateTime, ROLE_LABELS } from "@/lib/format";

export default function Users() {
  const { data, loading, error, reload } = useApi("/users");
  const clients = useClientOptions();
  const [editing, setEditing] = useState(null);
  const isNew = editing && !editing.id;
  const fields = [
    { name: "name", label: "Nombre", required: true, minLength: 2 },
    { name: "email", label: "Correo", type: "email", required: true, disabled: !isNew },
    { name: "role", label: "Rol", type: "select", required: true, options: Object.entries(ROLE_LABELS).map(([value, label]) => ({ value, label })) },
    { name: "client_id", label: "Cliente vinculado (solo rol Cliente)", type: "select", options: clients },
    { name: "password", label: isNew ? "Contraseña temporal" : "Nueva contraseña (opcional)", type: "password", required: isNew, minLength: 8 },
    ...(isNew ? [] : [{ name: "active", label: "Usuario activo", type: "checkbox" }]),
  ];
  return (
    <div>
      <PageHeader title="Usuarios" subtitle="Los usuarios no se eliminan: se desactivan."
        actions={<Button onClick={() => setEditing({})} data-testid="new-user-button"><Plus className="mr-2 h-4 w-4" />Nuevo usuario</Button>} />
      <ErrorBox text={error} />
      <DataTable testid="users-table" loading={loading} rows={data} onRowClick={setEditing}
        columns={[{ key: "name", label: "Nombre", render: (r) => <span className="font-medium text-slate-900">{r.name}</span> }, { key: "email", label: "Correo" },
          { key: "role", label: "Rol", render: (r) => ROLE_LABELS[r.role] }, { key: "last_login", label: "Último acceso", render: (r) => fmtDateTime(r.last_login) },
          { key: "active", label: "Estado", render: (r) => <StatusBadge status={r.active ? "Activo" : "Cancelado"} /> }]} />
      <FormDialog open={Boolean(editing)} onOpenChange={(o) => !o && setEditing(null)} title={isNew ? "Nuevo usuario" : "Editar usuario"} testid="user-form" fields={fields}
        initial={isNew ? { role: "staff" } : editing}
        onSubmit={async ({ email, ...v }) => {
          const body = { ...v, client_id: v.role === "client" ? v.client_id : null };
          if (!body.password) delete body.password;
          if (isNew) await api.post("/users", { ...body, email }); else await api.patch(`/users/${editing.id}`, body);
          toast.success("Usuario guardado"); reload();
        }} />
    </div>
  );
}
